import React from 'react';

import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { token } from '@atlaskit/tokens';

import { wacToken } from '@/libraries/design/foundations';

import { servcoTemplateMessages } from './servco-template-messages';

const termsTextStyle = css({
	fontFamily: wacToken('font.charlie.text'),
	fontSize: '12px',
	fontWeight: token('font.weight.regular'),
	lineHeight: '16px',
	color: token('color.text.subtlest'),
	textAlign: 'center',
	margin: 0,
	marginBlockStart: token('space.200'),
});

const termsLinkStyle = css({
	color: token('color.link'),
	textDecoration: 'none',
	'&:hover': {
		textDecoration: 'underline',
	},
});

/**
 * JSMGROWTH-583: legal notice shown below the template cards when a ServCo
 * (JSM / CSM) template is selected. Rendered outside the card buttons so the
 * links are not nested inside another interactive control.
 */
export const TemplateLegalNotice: React.FC = () => {
	const customerAgreementLink = (
		<a
			href="https://www.atlassian.com/legal/customer-agreement"
			target="_blank"
			rel="noopener noreferrer"
			css={termsLinkStyle}
		>
			<FormattedMessage {...servcoTemplateMessages.customerAgreementLinkText} />
		</a>
	);

	const privacyPolicyLink = (
		<a
			href="https://www.atlassian.com/legal/privacy-policy"
			target="_blank"
			rel="noopener noreferrer"
			css={termsLinkStyle}
		>
			<FormattedMessage {...servcoTemplateMessages.privacyPolicyLinkText} />
		</a>
	);

	return (
		<p css={termsTextStyle} data-testid="servco-template-legal-notice">
			<FormattedMessage
				{...servcoTemplateMessages.legalNotice}
				values={{ customerAgreementLink, privacyPolicyLink }}
			/>
		</p>
	);
};
